import { useEffect, useState } from 'react';
import { DOCUMENT_TYPES } from '../data/gestionDocumentaireTypes';
import { getTemplateDocumentLinks } from '../services/intakeTemplateLinksService';

interface TemplateLinkedDocumentCellProps {
  templateId: string;
  mode: 'type' | 'domain';
}

export default function TemplateLinkedDocumentCell({ templateId, mode }: TemplateLinkedDocumentCellProps) {
  const [codes, setCodes] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!templateId) return;

    const load = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const result = await getTemplateDocumentLinks(templateId);
        setCodes(result);
      } catch (e: any) {
        console.error('Erreur chargement types liés pour template', templateId, e);
        setError(e?.message || 'Erreur de chargement');
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, [templateId]);

  if (isLoading) {
    return <span className="text-[10px] text-gray-400">Chargement...</span>;
  }

  if (error) {
    return <span className="text-[10px] text-red-500">Erreur</span>;
  }

  if (!codes || codes.length === 0) {
    return <span className="text-[10px] text-gray-400">Aucun type lié</span>;
  }

  const mapped = codes
    .map((code) => DOCUMENT_TYPES.find((dt) => dt.code === code))
    .filter((v): v is (typeof DOCUMENT_TYPES)[number] => !!v);

  if (mapped.length === 0) {
    return <span className="text-[10px] text-gray-400">Types inconnus ({codes.join(', ')})</span>;
  }

  if (mode === 'type') {
    return (
      <div className="flex flex-wrap gap-1">
        {mapped.map((dt) => (
          <span
            key={dt.code}
            className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 text-[10px] font-medium text-gray-700"
          >
            {dt.title} <span className="ml-1 text-[9px] text-gray-500">({dt.code})</span>
          </span>
        ))}
      </div>
    );
  }

  // mode === 'domain'
  const domains = Array.from(new Set(mapped.map((dt) => dt.domain)));

  return (
    <div className="flex flex-wrap gap-1">
      {domains.map((domain) => (
        <span
          key={domain}
          className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 text-[10px] font-medium text-gray-700"
        >
          {domain}
        </span>
      ))}
    </div>
  );
}









